import { Injectable } from '@angular/core';
import {
  BookingProductType,
  isBookingProductTypeTariff,
  VoucherBookingCountdown
} from '@products/models/booking.model';
import { TariffPersonalizationType } from '@products/models/tariff.model';
import { getCountdownTimestamp } from '@shared/app-utils';

@Injectable({
  providedIn: 'root'
})
export class BookingCountdownService {
  /**
   * Maps booking product types to voucher booking countdowns
   * @param bookingProductTypes Booking product types from payload
   * @param tariffReleaseInMinutes In how many seconds does tariff release
   * @returns Array of voucher countdowns
   */
  mapBookingProductTypesToVoucherBookingCountdowns(
    bookingProductTypes: BookingProductType[],
    tariffReleaseInMinutes: number
  ): VoucherBookingCountdown[] {
    const anonymousBookingProductTypes: BookingProductType[] = bookingProductTypes.filter(
      (bookingProductType) =>
        isBookingProductTypeTariff(bookingProductType) &&
        bookingProductType.tariffs.some(
          ({ personalizationType }) => personalizationType === TariffPersonalizationType.Anonymous
        )
    );
    const vouchersBookingCountdowns: VoucherBookingCountdown[] = [];
    const filteredBookingProductTypes: BookingProductType[] = anonymousBookingProductTypes.length
      ? anonymousBookingProductTypes
      : bookingProductTypes;

    filteredBookingProductTypes.forEach((bookingProductType) => {
      if (isBookingProductTypeTariff(bookingProductType)) {
        bookingProductType.tariffs.forEach(({ voucherCode, activatedTimestamp, personalizationType }) => {
          const expiryTimestamp: number = getCountdownTimestamp(tariffReleaseInMinutes, activatedTimestamp);
          const isAnonymous: boolean = personalizationType === TariffPersonalizationType.Anonymous;
          const voucherBookingCountdown: VoucherBookingCountdown = { voucherCode, expiryTimestamp, isAnonymous };

          vouchersBookingCountdowns.push(voucherBookingCountdown);
        });
      }
    });

    return vouchersBookingCountdowns;
  }
}
